export default __webpack_public_path__ + "static/maybank-c82088c0af5175bd4758bdfde16c81ad.png";